module.exports = __webpack_public_path__ + "static/media/thumb_paiste.b4464292.jpg";